import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import SnackAlerts from 'global/components/snack-alerts';
import {
  ACCESS_ALERT_QUERY,
  ACCESS_ALERT_MESSAGE,
  SHARE_DELETED_ALERT_VALUE,
  SHARE_DELETED_ALERT_MESSAGE,
  NO_CREATE_PERMISSION_ALERT_VALUE,
  NO_CREATE_PERMISSION_ALERT_MESSAGE,
  TEMPLATE_NOT_FOUND_ALERT_VALUE,
  TEMPLATE_NOT_FOUND_ALERT_MESSAGE,
} from 'global/utils/loginRedirect';

// Map specific accessAlert values to their plain-text messages. Anything not
// listed falls back to the generic doesn't-exist/no-access copy.
const ALERT_MESSAGES = {
  [SHARE_DELETED_ALERT_VALUE]: SHARE_DELETED_ALERT_MESSAGE,
  [NO_CREATE_PERMISSION_ALERT_VALUE]: NO_CREATE_PERMISSION_ALERT_MESSAGE,
  [TEMPLATE_NOT_FOUND_ALERT_VALUE]: TEMPLATE_NOT_FOUND_ALERT_MESSAGE,
};

// PFM-2565: Watches the URL for ?accessAlert=1 (set by useAccessRedirect when an
// authenticated user lands on inaccessible content), shows a snackbar with the
// standard message, then strips the query param so the alert doesn't reappear.
const AccessAlertSnack = () => {
  const location = useLocation();
  const history = useHistory();
  const [alerts, setAlerts] = useState();

  useEffect(() => {
    const search = (location.search || '').replace(/^\?/, '');
    const parsed = qs.parse(search);
    if (parsed[ACCESS_ALERT_QUERY]) {
      // PFM-2640 / PFM-2545: specific accessAlert values carry their own copy
      // (deleted share, no create-permission, template-not-found); everything else
      // falls back to the generic doesn't-exist/no-access message.
      const message = ALERT_MESSAGES[parsed[ACCESS_ALERT_QUERY]] || ACCESS_ALERT_MESSAGE;
      setAlerts({ message, severity: 'warning' });

      // Strip the alert query param so refreshes don't re-trigger the alert.
      const remaining = { ...parsed };
      delete remaining[ACCESS_ALERT_QUERY];
      const remainingStr = qs.stringify(remaining);
      const newSearch = remainingStr ? `?${remainingStr}` : '';
      history.replace(`${location.pathname}${newSearch}${location.hash || ''}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return <SnackAlerts alerts={alerts} setAlerts={setAlerts} />;
};

export default AccessAlertSnack;
